import React, { memo } from 'react'
import clsx from 'clsx'
import { Box, Divider } from '@material-ui/core'
import PropTypes from 'prop-types'
import ItemBorder from '@v4/components/common/ItemBorder'
import Image from '@v4/components/common/Image'
import EditableHTML from '@v4/components/common/EditableHTML'
import EditableContainer from '@v4/components/common/EditableContainer'
import StarsRating from '@v4/components/common/StarsRating'
import { useItem } from './Item.hooks'

const Item = props => {
	const [
		{
			classes,
			image,
			withImage,
			logoImage,
			withRightImage,
			itemKey,
			group,
			rating,
			ratingStarColor,

			text,
			textConfig,
			textEditable,
			textKey,

			personText,
			personTextConfig,
			personTextEditable,
			personTextKey,
		},
		{
			handleImageClick,
			handleImageLogoClick,
			handleClick,
			handleRatingClick,

			handleTextClick,
			handleTextChange,

			handlePersonTextClick,
			handlePersonTextChange,
		},
	] = useItem(props)

	return (
		<ItemBorder itemKey={itemKey} group={group} outlineOffset={-3}>
			<Box className={clsx(classes.root, 'testimonial7-item')} onClick={handleClick}>
				<Box className={classes.starsWrap} onClick={handleRatingClick}>
					<StarsRating rating={rating} itemKey={itemKey} color={ratingStarColor} />
				</Box>
				<EditableContainer
					visible={!!text}
					fieldConfig={textConfig}
					onAdd={handleTextChange}
					editable={textEditable}
					usePaperColors
					wrapper={({ children }) => (text ? children : <Box width="100%">{children}</Box>)}
				>
					<EditableHTML
						key={textKey}
						usePaperColors
						className={clsx(classes.text, 'testimonial7-item-text-block')}
						align="left"
						html={text}
						editable={textEditable}
						onClick={handleTextClick}
						onChange={handleTextChange}
					/>
				</EditableContainer>

				<Box className={clsx(classes.person)}>
					{withImage && (
						<Image
							className={clsx(classes.leftImage, 'testimonial7-item-image-left')}
							metaData={image}
							onClick={handleImageClick}
						/>
					)}
					<EditableContainer
						visible={!!personText}
						fieldConfig={personTextConfig}
						onAdd={handlePersonTextChange}
						editable={personTextEditable}
						usePaperColors
					>
						<EditableHTML
							key={personTextKey}
							usePaperColors
							className={clsx(classes.personText, 'testimonial7-item-description-text-block')}
							align="left"
							html={personText}
							editable={personTextEditable}
							onClick={handlePersonTextClick}
							onChange={handlePersonTextChange}
						/>
					</EditableContainer>
					{withRightImage && (
						<>
							<Divider orientation="vertical" className={classes.divider} />
							<Image
								className={clsx(classes.rightImage, 'testimonial7-item-image-right')}
								metaData={logoImage}
								onClick={handleImageLogoClick}
							/>
						</>
					)}
				</Box>
			</Box>
		</ItemBorder>
	)
}

Item.propTypes = {
	group: PropTypes.string.isRequired,
	index: PropTypes.number.isRequired,
	itemKey: PropTypes.string.isRequired,
	rounding: PropTypes.number.isRequired,
	image: PropTypes.string,
	itemImageLogo: PropTypes.string,
	text: PropTypes.string,
	textConfig: PropTypes.object,
	personItemText: PropTypes.string,
}

export default memo(Item)
